// extracted by mini-css-extract-plugin
module.exports = {"choice__item--grow":"choice_choice__item--grow__Csxau","choice__option":"choice_choice__option__isndr","truncate":"choice_truncate__sohw5"};